export default "__VITE_ASSET__BSISktQb__"